export function displayName(raw) {
  if (raw == null) return ''
  const s = String(raw)
  const idx = s.indexOf('|')
  const base = idx >= 0 ? s.slice(0, idx) : s
  return base.trim()
}
